import Link from "next/link";
import { contactUsFormCall } from "../../services/publicCall";
import publicApiCall from "../../utils/axiosCall";
import { validateEmail } from "../../utils/validation";
import { errorToast } from "../../utils/toast";
import React, { useState } from "react";

const ContactForm = () => {
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading) return;

    const form = event.target;

    // Get form data
    const formData = new FormData(form);

    // Convert FormData to a plain object
    const formObject = {};
    formData.forEach((value, key) => {
      formObject[key] = value;
    });

    // The `required` attribute lets a value of only spaces through, so trim
    // before checking and send the trimmed values.
    formObject["name"] = (formObject["name"] || "").trim();
    formObject["email"] = (formObject["email"] || "").trim();
    formObject["message"] = (formObject["message"] || "").trim();

    if (!formObject["name"]) {
      errorToast("Please enter your name");
      return;
    }
    if (!validateEmail(formObject["email"])) {
      errorToast("Please enter a valid email address");
      return;
    }
    if (!formObject["message"]) {
      errorToast("Please enter a message");
      return;
    }

    // Adding a new key-value pair of Subject
    formObject["subject"] = "Impactoverse Contact Query";

    setLoading(true);
    try {
      // contactUsFormCall already fires a success/error toast, so we don't add another here.
      await contactUsFormCall(formObject);
      form.reset();
    } catch (error) {
      // Handle API call error
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <form id="contact-form" method="post" onSubmit={handleSubmit}>
      <div className="flex flex-col sm:flex-row sm:space-x-7">
        <div className="mb-6 w-full sm:w-1/2">
          <label className="font-display text-jacarta-700 mb-1 block text-sm dark:text-white">
            Name<span className="text-red">*</span>
          </label>
          <input
            name="name"
            className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
            id="name"
            type="text"
            required
          />
        </div>

        <div className="mb-6 w-full sm:w-1/2">
          <label className="font-display text-jacarta-700 mb-1 block text-sm dark:text-white">
            Email<span className="text-red">*</span>
          </label>
          <input
            name="email"
            className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
            id="email"
            type="email"
            required
          />
        </div>
      </div>

      <div className="mb-4">
        <label className="font-display text-jacarta-700 mb-1 block text-sm dark:text-white">
          Message<span className="text-red">*</span>
        </label>
        <textarea
          id="message"
          className="contact-form-input dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white"
          required
          name="message"
          rows="5"
        ></textarea>
      </div>

      <div className="mb-6 flex items-center space-x-2">
        <input
          type="checkbox"
          id="contact-form-consent-input"
          name="optIn"
          className="checked:bg-accent dark:bg-jacarta-600 text-accent border-jacarta-200 focus:ring-accent/20 dark:border-jacarta-500 h-5 w-5 self-start rounded focus:ring-offset-0 cursor-pointer"
        />
        <label className="dark:text-jacarta-200 text-sm">
          Click to opt out of our Newletter & Updates{" "}
        </label>
      </div>

      <button
        type="submit"
        disabled={loading}
        className="bg-accent shadow-accent-volume hover:bg-accent-dark rounded-full py-3 px-8 text-center font-semibold text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        id="contact-form-submit"
      >
        {loading ? "Submitting…" : "Submit"}
      </button>

      <div
        id="contact-form-notice"
        className="relative mt-4 hidden rounded-lg border border-transparent p-4"
      ></div>
    </form>
  );
};

export default ContactForm;
